export const wordCloud = {
    title: 'ワードクラウド',

    wordCloudChartTitle: '企業のワードクラウド',
    wordCloudBarTitle: '企業の頻出ワード',
    wordCloudCompanyBarTitle: 'ワードによる企業検索'
}
